
import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="text-xl font-bold text-teal-600 cursor-pointer">
              NeighborHub
            </Link>
            <div className="hidden md:flex items-center gap-6">
              <Link to="/meetings" className="font-medium transition-colors hover:opacity-80 cursor-pointer text-gray-700">
                Meetings
              </Link>
              <Link to="/dues" className="font-medium transition-colors hover:opacity-80 cursor-pointer text-gray-700">
                Dues
              </Link>
              <Link to="/documents" className="font-medium transition-colors hover:opacity-80 cursor-pointer text-gray-700">
                Documents
              </Link>
              <Link to="/qa" className="font-medium transition-colors hover:opacity-80 cursor-pointer text-gray-700">
                Q&A
              </Link>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/profile" className="font-medium transition-colors hover:opacity-80 cursor-pointer text-gray-700">
              Profile
            </Link>
            <Link
              to="/signup"
              className="bg-teal-500 text-white px-6 py-2 rounded-lg font-medium hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Sign Up
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
